import { useSelector } from 'react-redux';
import { useState } from 'react';

import { Button } from '../../../UIPackage/MainModule/components/Button';
import styles from './KnmMassCancelHeader.module.scss';
import {
  getKnmDataId,
  getKnmDataMassCancel,
  getKnmErknmKnoOrganizationFormValue,
  getKnmIsErknmStatusTypeCanceled,
} from '../../MainModule/selectors/knmSelectors';
import { KnmMassCancelDetailModal } from './KnmMassCancelDetailModal';
import { getAccountOrganizationsWithDistrictData } from '../../../CorePackage/AccountModule/selectors/accountSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { KnmMassCancelModal } from './KnmMassCancelModal';

export const KnmMassCancelHeader = () => {
  const passportId = useSelector(getKnmDataId);
  const massCancel = useSelector(getKnmDataMassCancel);
  const isErknmStatusTypeCanceled = useSelector(getKnmIsErknmStatusTypeCanceled);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const knoOrganization = useSelector(getKnmErknmKnoOrganizationFormValue);
  const userKnoOrganisations = useSelector(getAccountOrganizationsWithDistrictData).kno;
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [isShowCancelModal, setIsShowCancelModal] = useState(false);
  const isCancelButtonEnabled =
    isSupervisor &&
    userKnoOrganisations.some(
      item => item.id === knoOrganization?.id?.toString() || item.id === knoOrganization?.idStr?.toString(),
    );

  if (!massCancel?.isCancellationAllowed || isErknmStatusTypeCanceled) {
    return null;
  }

  return (
    <>
      <div className={styles.Block}>
        <span className={styles.WarningText}>
          Внимание! Данное мероприятие отмечено прокурором как подлежащее отмене!
        </span>
        <Button
          text="Просмотреть основание"
          variant="link"
          color="primary"
          type="button"
          onClick={() => setIsShowDetailModal(true)}
        />
        <div className={styles.Space}></div>
        <Button
          text="Отменить мероприятиe"
          color="danger"
          type="button"
          disabled={!isCancelButtonEnabled}
          onClick={() => setIsShowCancelModal(true)}
        />
      </div>
      <KnmMassCancelDetailModal
        visible={isShowDetailModal}
        onClose={() => setIsShowDetailModal(false)}
        massCancel={massCancel}
      />
      <KnmMassCancelModal
        visible={isShowCancelModal}
        onClose={() => setIsShowCancelModal(false)}
        passportId={passportId}
      />
    </>
  );
};
